import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section
      id="home"
      className="min-h-screen bg-[#0a0a0a] flex flex-col items-center justify-center text-center px-4 pt-20 pb-16"
    >
      {/* Bible image */}
      <div className="w-24 h-24 mb-6 flex items-center justify-center">
        <img src="https://storage.readdy-site.link/project_files/643939e0-73b1-412d-a6cb-581a1ba0e14c/d7ca5519-1c4a-4f93-9ca8-2ced6526acdd_bible-image.jpg?v=5a2efdf43c26bdf7c8a26d76507b46fb" alt="Bible" className="w-full h-full object-cover rounded-xl" />
      </div>

      {/* Title */}
      <h1 className="text-4xl md:text-6xl font-bold text-white mb-4 leading-tight">
        Welcome to{" "}
        <span className="text-[#ef4444]">AppleSMP Bible</span>
      </h1>

      {/* Subtitle */}
      <p className="text-[#888] text-base md:text-lg max-w-xl mx-auto mb-8 leading-relaxed">
        Read scripture in your translation of choice, grow daily in faith through devotionals, 
        and build a lifelong habit of reading God&apos;s Word.
      </p>

      {/* CTA Buttons */}
      <div className="flex flex-col sm:flex-row items-center gap-3 mb-10">
        <Link
          to="/scripture"
          className="flex items-center gap-2 bg-[#ef4444] hover:bg-[#dc2626] text-white text-sm font-medium px-5 py-2.5 rounded-md transition-colors cursor-pointer whitespace-nowrap"
        >
          Read Scripture
          <i className="ri-arrow-right-line" />
        </Link>
        <Link
          to="/devotionals"
          className="flex items-center gap-2 bg-transparent border border-[#2e2e2e] hover:border-[#444] text-white text-sm font-medium px-5 py-2.5 rounded-md transition-colors cursor-pointer whitespace-nowrap"
        >
          Daily Devotionals
        </Link>
      </div>

      {/* Info cards */}
      <div className="w-full max-w-md flex flex-col gap-2">
        <div className="bg-[#111] border border-[#1e1e1e] rounded-lg px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 flex items-center justify-center bg-[#1e1e1e] rounded-md">
              <i className="ri-book-2-line text-[#ef4444] text-sm" />
            </div>
            <div className="text-left">
              <p className="text-white text-sm font-medium">66 Books of the Bible</p>
              <p className="text-[#555] text-xs">KJV, NKJV, NIV, ESV, NLT &amp; more</p>
            </div>
          </div>
          <i className="ri-arrow-right-s-line text-[#444]" />
        </div>

        <div className="bg-[#111] border border-[#1e1e1e] rounded-lg px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 flex items-center justify-center bg-[#1e1e1e] rounded-md">
              <i className="ri-calendar-check-line text-[#ef4444] text-sm" />
            </div>
            <div className="text-left">
              <p className="text-white text-sm font-medium">365 Day Track</p>
              <p className="text-[#555] text-xs">Full Bible &middot; Chronological order</p>
            </div>
          </div>
          <i className="ri-arrow-right-s-line text-[#444]" />
        </div>
      </div>
    </section>
  );
}
